export default function AppSection() {
  const features = [
    { icon: 'ri-download-cloud-2-line', label: '极速下载' },
    { icon: 'ri-smartphone-line', label: '移动追剧' },
    { icon: 'ri-wifi-line', label: '离线缓存' },
    { icon: 'ri-notification-3-line', label: '更新提醒' },
  ];

  return (
    <section id="app" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              手机APP
            </h2>
            <p className="text-sm text-foreground-400 mb-8 max-w-md mx-auto lg:mx-0 leading-relaxed">
              下载极速影视手机客户端，随时随地流畅追剧。支持iOS和Android双平台，离线缓存、倍速播放、弹幕互动等专属功能等你体验。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
              {features.map((f, i) => (
                <div key={i} className="flex flex-col items-center lg:items-start gap-2 p-4 bg-background-50 rounded-xl border border-background-200/50">
                  <i className={`${f.icon} text-accent-500 text-xl`}></i>
                  <span className="text-xs text-foreground-300 whitespace-nowrap">{f.label}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold rounded-lg text-sm whitespace-nowrap transition-all duration-200 cursor-pointer no-underline"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500/15 hover:bg-accent-500/25 text-accent-400 font-semibold rounded-lg text-sm whitespace-nowrap transition-all duration-200 cursor-pointer no-underline border border-accent-500/30"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版下载
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-xs lg:max-w-sm">
            <div className="relative mx-auto w-56">
              <div className="absolute -inset-6 bg-primary-500/8 rounded-[3rem] blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20movie%20streaming%20app%20interface%20on%20dark%20background%2C%20modern%20mobile%20UI%20with%20warm%20cinematic%20colors%2C%20floating%20phone%20mockup%2C%20clean%20minimal%20presentation%2C%20no%20text%20visible%2C%20premium%20app%20showcase%20aesthetic&width=500&height=900&seq=app-01&orientation=portrait"
                alt="极速影视手机APP"
                className="w-full h-auto object-contain relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}